module.exports = __webpack_public_path__ + "img/center-info-structure6-1.50890134.png";